'use client';

import Image from 'next/image';
import { useState } from 'react';

export default function ProductGallery({ images, name }: { images: { url: string; alt: string }[]; name: string }) {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState<{ x: number; y: number } | null>(null);
  const current = images[active] ?? images[0];

  if (!current) {
    return <div className="al-tile aspect-[4/5] w-full bg-gradient-to-br from-al-maroon to-al-ink" />;
  }

  return (
    <div className="flex flex-col-reverse gap-4 lg:flex-row">
      {images.length > 1 && (
        <ul className="flex gap-3 lg:w-20 lg:flex-col" aria-label="Product images">
          {images.map((img, i) => (
            <li key={img.url} className="w-16 lg:w-full">
              <button
                type="button"
                onClick={() => setActive(i)}
                className={`al-tile relative block aspect-[4/5] w-full transition ${
                  i === active ? 'ring-1 ring-al-gold' : 'opacity-60 hover:opacity-100'
                }`}
                aria-label={`Show image ${i + 1} of ${images.length}`}
                aria-current={i === active ? 'true' : undefined}
              >
                <Image src={img.url} alt="" fill sizes="80px" className="object-cover" />
              </button>
            </li>
          ))}
        </ul>
      )}

      <div
        className="al-tile relative aspect-[4/5] w-full flex-1 cursor-zoom-in"
        onMouseMove={(e) => {
          const r = e.currentTarget.getBoundingClientRect();
          setZoom({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100 });
        }}
        onMouseLeave={() => setZoom(null)}
      >
        <Image
          src={current.url}
          alt={current.alt || name}
          fill
          priority
          sizes="(min-width:1024px) 50vw, 100vw"
          className="object-cover transition-transform duration-300 ease-out"
          style={zoom ? { transform: 'scale(1.8)', transformOrigin: `${zoom.x}% ${zoom.y}%` } : undefined}
        />
      </div>
    </div>
  );
}
